// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__Htm_U","legacyBtn":"MutateMid_legacyBtn__2dqAU"};